module.exports = __webpack_public_path__ + "static/fonts/Arita-dotumM.658649e.woff";